/* ══════════════════════════════════════════════════════
   BRO PERSO — Personnalisation fields logic
   Handles:
   1. Validation on product page form submit
   2. Dynamic injection in quick-add drawer
   3. Line item properties for Shopify admin
   ──────────────────────────────────────────────────────
   <script src="{{ 'bro-perso.js' | asset_url }}" defer></script>
   ══════════════════════════════════════════════════════ */
(function() {
  'use strict';

  /* ══════════════════════════════════════
     1. PRODUCT PAGE — Form validation
     ══════════════════════════════════════ */
  var bpForm = document.getElementById('bpF');
  if (bpForm) {
    var persoBlock = bpForm.closest('section, .bp')
      ? bpForm.querySelector('[data-bro-perso]') || bpForm.closest('section').querySelector('[data-bro-perso]')
      : null;

    /* Also check if perso block is inside the form */
    if (!persoBlock) persoBlock = bpForm.querySelector('[data-bro-perso]');

    if (persoBlock) {
      bpForm.addEventListener('submit', function(e) {
        var inputs = persoBlock.querySelectorAll('[data-bro-perso-input]');
        var valid = true;

        inputs.forEach(function(inp) {
          inp.classList.remove('bro-perso--error');
          if (inp.hasAttribute('required') && inp.value.trim() === '') {
            inp.classList.add('bro-perso--error');
            valid = false;
          }
        });

        if (!valid) {
          e.preventDefault();
          e.stopImmediatePropagation();
          inputs[0].focus();
          return false;
        }
      }, true); /* useCapture = true so we fire BEFORE the theme's handler */

      /* Clear error on input */
      persoBlock.querySelectorAll('[data-bro-perso-input]').forEach(function(inp) {
        inp.addEventListener('input', function() {
          inp.classList.remove('bro-perso--error');
        });
      });
    }
  }

  /* ══════════════════════════════════════
     2. QUICK-ADD DRAWER — Dynamic inject
     ══════════════════════════════════════ */
  var persoHTML = [
    '<div class="bro-perso" data-bro-perso>',
    '  <div class="bro-perso__head">',
    '    <svg class="bro-perso__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">',
    '      <path d="M20.38 3.46L16.12 21.5a1 1 0 01-1.22.72L3.54 18.8a1 1 0 01-.72-1.22L7.08 2.46"/>',
    '      <path d="M7.08 2.46a2.5 2.5 0 013.04-1.8l8.46 2.16a2.5 2.5 0 011.8 3.04"/>',
    '      <path d="M11 10l2 6"/>',
    '    </svg>',
    '    <span class="bro-perso__label">Personnalise ton v\u00eatement</span>',
    '  </div>',
    '  <div class="bro-perso__fields">',
    '    <div class="bro-perso__field">',
    '      <label class="bro-perso__field-label">',
    '        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
    '        Ton blaze',
    '      </label>',
    '      <input type="text" name="properties[Blaze]" class="bro-perso__input" placeholder="Ex : AXEL" maxlength="20" autocomplete="off" required data-bro-perso-input>',
    '    </div>',
    '    <div class="bro-perso__field">',
    '      <label class="bro-perso__field-label">',
    '        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9h16M4 15h16M10 3L8 21M16 3l-2 18"/></svg>',
    '        Ton num\u00e9ro',
    '      </label>',
    '      <input type="text" name="properties[Num\u00e9ro]" class="bro-perso__input" placeholder="Ex : 10" maxlength="4" autocomplete="off" required data-bro-perso-input>',
    '    </div>',
    '    <span class="bro-perso__hint">Tirets, points et caract\u00e8res sp\u00e9ciaux accept\u00e9s</span>',
    '  </div>',
    '</div>'
  ].join('\n');

  /* Cache product tags to know which products are "perso" */
  var persoCache = {};

  function isPersoProduct(handle, callback) {
    if (persoCache[handle] !== undefined) {
      callback(persoCache[handle]);
      return;
    }
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        var isPerso = product.tags && product.tags.indexOf('perso') > -1;
        persoCache[handle] = isPerso;
        callback(isPerso);
      })
      .catch(function() {
        persoCache[handle] = false;
        callback(false);
      });
  }

  function injectPersoInDrawer(drawer) {
    /* Don't inject twice */
    if (drawer.querySelector('[data-bro-perso]')) return;

    /* Find product handle */
    var productInfo = drawer.querySelector('product-info[data-url]');
    if (!productInfo) return;
    var url = productInfo.getAttribute('data-url') || '';
    var handle = url.replace('/products/', '').split('?')[0];
    if (!handle) return;

    isPersoProduct(handle, function(isPerso) {
      if (!isPerso) return;
      if (drawer.querySelector('[data-bro-perso]')) return; /* re-check after async */

      /* Find submit button to inject before it */
      var submitBtn = drawer.querySelector('.product__submit, button[name="add"], .product__submit__add');
      if (!submitBtn) return;
      var submitParent = submitBtn.closest('.product__submit') || submitBtn.parentElement;

      var div = document.createElement('div');
      div.innerHTML = persoHTML;
      var persoEl = div.firstElementChild;

      submitParent.parentElement.insertBefore(persoEl, submitParent);

      /* Bind validation + clear */
      persoEl.querySelectorAll('[data-bro-perso-input]').forEach(function(inp) {
        inp.addEventListener('input', function() {
          inp.classList.remove('bro-perso--error');
        });
      });
    });
  }

  /* Watch for quick-add drawers appearing */
  function scanDrawers() {
    var drawers = document.querySelectorAll('.product-quick-add__content');
    drawers.forEach(function(drawer) {
      if (!drawer.dataset.broPersoScanned) {
        drawer.dataset.broPersoScanned = '1';
        /* Wait for drawer content to load */
        setTimeout(function() { injectPersoInDrawer(drawer); }, 300);
        setTimeout(function() { injectPersoInDrawer(drawer); }, 800);
      }
    });
  }

  new MutationObserver(scanDrawers).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', function() { setTimeout(scanDrawers, 600); });

  /* ══════════════════════════════════════
     3. INTERCEPT quick-add /cart/add
        to inject properties
     ══════════════════════════════════════ */
  var origFetch = window.__broPersoOrigFetch || window.fetch;
  /* Don't double-patch if bro-quick-add-fix.js already patched */
  if (!window.__broPersoPatched) {
    window.__broPersoPatched = true;

    var prevFetch = window.fetch;
    window.fetch = function(url, options) {
      if (typeof url === 'string' && url.indexOf('/cart/add') > -1 && options && options.body) {
        var persoProps = getActivePersoProps();
        if (persoProps) {
          try {
            if (typeof options.body === 'string') {
              var data = JSON.parse(options.body);
              if (!data.properties) data.properties = {};
              data.properties['Blaze'] = persoProps.blaze;
              data.properties['Numéro'] = persoProps.numero;
              options.body = JSON.stringify(data);
            } else if (options.body instanceof FormData) {
              options.body.set('properties[Blaze]', persoProps.blaze);
              options.body.set('properties[Numéro]', persoProps.numero);
            }
          } catch(e) {}
        }
      }
      return prevFetch.apply(this, arguments);
    };
  }

  function getActivePersoProps() {
    /* Check quick-add drawer first (if visible) */
    var openDrawer = document.querySelector('.product-quick-add.is-visible, .product-quick-add[open], dialog.product-quick-add[open]');
    if (openDrawer) {
      var perso = openDrawer.querySelector('[data-bro-perso]');
      if (perso) {
        var blaze = perso.querySelector('[name="properties[Blaze]"]');
        var numero = perso.querySelector('[name="properties[Numéro]"]');
        if (blaze && numero && (blaze.value.trim() || numero.value.trim())) {
          /* Validate */
          var valid = true;
          [blaze, numero].forEach(function(inp) {
            inp.classList.remove('bro-perso--error');
            if (inp.hasAttribute('required') && inp.value.trim() === '') {
              inp.classList.add('bro-perso--error');
              valid = false;
            }
          });
          if (!valid) return null;
          return { blaze: blaze.value.trim(), numero: numero.value.trim() };
        }
      }
    }
    return null;
  }

})();
